module.exports = __webpack_public_path__ + "media/icons/purple-diamond-8c588c10.png";